import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=5c19eddd&scoped=true&"
import script from "./Forbidden.vue?vue&type=script&lang=js&"
export * from "./Forbidden.vue?vue&type=script&lang=js&"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=5c19eddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c19eddd",
  null
  
)

export default component.exports